// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2F4-G","title":"ClientInsurance_title__3YRqo","itemText":"ClientInsurance_itemText__3y5nX"};